import React from 'react';

import {SkeletonData} from 'presentation/components/ChangeData/SkeletonData';
import {translations} from 'presentation/translations-new';
import {DataAccordion} from '../DataAccordion';

const {changeData} = translations['pt-br'].privateFlow.profile;

export function AddressLoading() {
	return (
		<DataAccordion
			hideIcon={true}
			expanded={true}
			handleChangeExpanded={() => {}}
			title={changeData.address.title}
			icon="perm-contact-callendar-filled">
			<SkeletonData type="address" />
		</DataAccordion>
	);
}
